<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { mapGetters } from 'vuex'

import Resizable from '@src/mixins/resizable.js'
import HowToUseStep from '@components/homepage/how-to-use-step.vue'

export default {
  components: {
    HowToUseStep,
    Swiper,
    SwiperSlide
  },
  mixins: [
    Resizable
  ],
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      howToUseSliderOptions: {
        allowTouchMove: true,
        spaceBetween: 8,
        pagination: {
          el: '.pagination',
          clickable: true,
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active'
        },
        breakpoints: {
          320: {
            slidesPerView: 1.05,
            slidesPerGroup: 1.05,
          },
        }
      },
    }
  },
  computed: {
    ...mapGetters('home', [
      'pageData',
    ]),
    ...mapGetters('translations', [
      'currentLanguage'
    ]),
    steps() {
      if (this.pageData.content) {
        const images = [this.pageData.how_to_use.web_images, this.pageData.how_to_use.app_images]

        return this.list.map((data, index) => {
          return {
            _id: index,
            image: [images[0][index], images[1][index]],
            caption: data,
          }
        })
      }
      return []
    },
  },
}
</script>

<template>
  <div class="wrapper">
    <div v-if="desktopScreen" class="how-to-use-steps">
      <HowToUseStep
          v-for="(item, index) in steps"
          :key="index"
          :step="item"
          :orderingNum="index + 1"
      />
    </div>
    <div v-else class="how-to-use-slider">
      <Swiper :options="howToUseSliderOptions">
        <SwiperSlide v-for="(item, index) in steps" :key="index" class="how-to-use-slide">
          <HowToUseStep
              :step="item"
              :orderingNum="index + 1"
          />
        </SwiperSlide>
        <div class="pagination" slot="pagination"></div>
      </Swiper>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.how-to-use-steps {
  display: grid;
  margin-top: 30px;
  column-gap: 20px;
  grid-template-columns: repeat(4, 1fr);
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .how-to-use-steps {
    display: grid;
    margin-top: 30px;
    column-gap: 20px;
    grid-template-columns: repeat(1, 1fr);
  }

  .how-to-use-slider {
    margin-top: 15px;
  }

  .pagination {
    margin-top: 24px;
  }
}
</style>
